import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ProductService } from "../providers/products.service";
import { ProductDetailsService } from "../providers/productdetails.service";
import { ConstantService } from '../providers/language.service';
import { Http, Response } from '@angular/http';
import { LanguageService } from '../providers/lang.service';
import { ActivatedRoute } from '@angular/router';
import { RestApiServices } from '../providers/rest.service';
import { CustomStorage } from '../providers/Custom-storage.service';
import { Router, NavigationStart } from '@angular/router';
import { SharedServiceService } from '../shared/shared-service.service';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { LoaderComponent } from '../loader/loader.component';
@Component({
  selector: 'app-topseller',
  templateUrl: './topseller.component.html'

})
export class TopsellerComponent {
  errorMsg: string;
  openOrdersDialog:boolean;
  openSessionDialog: boolean;
  operSessionDialog: boolean;
  public active: boolean = false
  cartItems = [];
  productDetails = [];
  promoImages = [];
  recommendedproducts = []; server_msg: string = ""; session_msg: string = "";
  topseller: string = ""; inspired: string = ""; uom: string = ""; alldepartments: string = "";
  item: string = ""; stock: string = ""; collection = []; addto_cart: string = ""; lbl_ok: string = "";
  item_number: string = ""; no_more_pdcts: string = ""; in_cart: string = "";
  showloading: boolean = true; Lbl_check_quantity: string = ""; lbl_uom: string = ""; lbl_qty: string = "";
  searchCount: number = 0; selcet_color: string = ""; selcet_size: string = ""; quantity_txt: string = "";
  numberoftimes: string = 'no_of_times_purchased';
  descending = true; unit_size: string = ""; unit_color: string = ""; left_instock: string = "";
  yes: string = ""; no: string = ""; cartMsg1: string = ""; cartMsg2: string = ""; cartMsg3: string = "";
  constructor(private productService: ProductService, private http: Http, private restApi: RestApiServices,
    private langService: LanguageService, private localstorage: CustomStorage, private sharedService: SharedServiceService, public router: Router) {

  }

  ngOnInit() {


    this.sharedService.changeFooterSelected('shop');

    this.langService.getJson().subscribe(data => {
      this.setLabels();
      //this.sharedService.setLoadingFlag(true);
      LoaderComponent.loadingV.next(true);
      this.localstorage.getItem('topSellingItems').subscribe(data => {

        if (data != null && data != undefined) {
          this.productDetails = data.response.top_selling_items;
          this.recommendedproducts = data.response.inspiredby_purchasing_history;
          this.promoImages = data.response.promo_images_data;
          // console.log(this.productDetails)
          this.showloading = false;
          LoaderComponent.loadingV.next(false);

        }
        // LoaderComponent.loadingV.next(false);
        this.restApi.getTopSellingProducts().subscribe(items => {
          if (items.response.error_message === '') {
            this.productDetails = items.response.top_selling_items;
            this.recommendedproducts = items.response.inspiredby_purchasing_history;
            this.promoImages = items.response.promo_images_data;
            this.showloading = false;
            LoaderComponent.loadingV.next(false);

          }
          else {
            this.operSessionDialog = !this.operSessionDialog;
            this.errorMsg = items.response.error_message
            LoaderComponent.loadingV.next(false);
          }

          //  this.collection.push( this.productDetails);
          this.searchCount = this.productDetails.length + this.recommendedproducts.length;
        });
      }, error => {
        this.operSessionDialog = !this.operSessionDialog;
        this.errorMsg = error.json().response
        LoaderComponent.loadingV.next(false);
      });
    });

    LoaderComponent.loadingV.next(true);
    this.cartItems = this.productService.loadCart();
    this.sharedService.setCategoryDetails('All Departments', null);

    console.log(this);
  }
  setLabels() {
    this.langService.getLangLabelValue("LblAllDepartments").then(result => {
      this.alldepartments = result;
    });
    this.langService.getLangLabelValue("LblThisWeeksTopSeller").then(result => {
      this.topseller = result;
    });
    this.langService.getLangLabelValue("LblInspiredByPurchasingHistory").then(result => {
      this.inspired = result;
    });
    this.langService.getLangLabelValue("LblInStock").then(result => {
      this.uom = result;
    });;
    this.langService.getLangLabelValue("LblInStock").then(result => {
      this.stock = result;
    });

    this.langService.getLangLabelValue("LblItem").then(result => {
      this.item_number = result; ``
    });

    this.langService.getLangLabelValue("LblAddToCart").then(res => {
      this.addto_cart = res;
    });
    this.langService.getLangLabelValue("Lblok").then(res => {
      this.lbl_ok = res
    });
    this.langService.getLangLabelValue("200_no_more_records").then(res => {
      this.no_more_pdcts = res
    });
    this.langService.getLangLabelValue("LblSelectColor").then(result => {
      this.selcet_color = result;
    });
    this.langService.getLangLabelValue("LblselectSize").then(result => {
      this.selcet_size = result;
    });
    this.langService.getLangLabelValue("LblenterQuantityHere").then(result => {
      this.quantity_txt = result;
    });
    this.langService.getLangLabelValue("LblYes").then(result => {
      this.yes = result;
    });
    this.langService.getLangLabelValue("LblNo").then(result => {
      this.no = result;
    });
    this.langService.getLangLabelValue("200_not_enough_qty_cart1").then(result => {
      this.cartMsg1 = result;
    });
    this.langService.getLangLabelValue("200_not_enough_qty_cart2").then(result => {
      this.cartMsg2 = result;
    });
    this.langService.getLangLabelValue("200_not_enough_qty_cart3").then(result => {
      this.cartMsg3 = result;
    });
    this.langService.getLangLabelValue("LblCheckQuantity").then(result => {
      this.Lbl_check_quantity = result;

    });
    this.langService.getLangLabelValue("LblColor").then(result => {
      this.unit_color = result;
    });
    this.langService.getLangLabelValue("LblSize").then(result => {
      this.unit_size = result;
    });
    this.langService.getLangLabelValue("LblLeftInStock").then(result => {
      this.left_instock = result;

    });
    this.langService.getLangLabelValue("LblInCart").then(result => {
      this.in_cart = result;
    });
    this.langService.getLangLabelValue("LblItemUOM").then(result => {
      this.lbl_uom = result;
    });
    this.langService.getLangLabelValue("LblUOMQty").then(result => {
      this.lbl_qty = result;
    });
    this.langService.getLangLabelValue("LblServerDown").then(result => {
      this.server_msg = result;
    });
    this.langService.getLangLabelValue("200_session_expired").then(result => {
      this.session_msg = result;
    });

  }
  addItemInCart(id: number): void {
    this.productService.addItem(id);
  }


  openSessionCheck() {
    // this.localstorage.emptyStorage();
    this.sharedService.removeAllData();
    this.openSessionDialog = !this.openSessionDialog;
    this.router.navigate(['/login'])
  }

  calculateWidth(image: any): string {
    const screenWidth = window.innerWidth; // Assuming you're running this code in a browser
    //console.log(screenWidth);
    const sidebarSizePercentage = 15;
    let sidebarWidth = (window.innerWidth * sidebarSizePercentage) / 100;
    let relativeWidth = ((screenWidth - sidebarWidth) * image.sizePercentage) / 100;
    relativeWidth = Math.min(relativeWidth, 1600 * (image.sizePercentage/100));
    return `${relativeWidth}`;
  }
}





// WEBPACK FOOTER //
// ./src/app/topseller/topseller.component.ts